import { lazy } from "react";

export const CreatorCampaigns = lazy(() => import("./CreatorCampaigns"));
